import "./index.less"
import React, { useEffect, useState } from "react"
import { Button, Image, Row } from "antd"
import { useNavigate, useLocation } from "react-router-dom"
import error401 from "@assets/images/401.png"
import error404 from "@assets/images/404.png"
import error500 from "@assets/images/500.png"
// import underMaintenance from "@assets/images/under-maintenance.png"
import { L } from "@lib/abpUtility"
// import WelcomePage from "../Welcome"

const exceptions = {
  undefined: {
    errorCode: "UNHANDLED_ERROR",
    errorImg: error404,
    errorTitle: "UNHANDLED_ERROR_TITLE",
    fallbackTitle: "Oops! Something went wrong",
    fallbackMessage: "An unexpected error occurred.",
  },
  "404": {
    errorCode: "404",
    errorImg: error404,
    errorTitle: "404_ERROR_TITLE",
    fallbackTitle: "Page Not Found",
    fallbackMessage: "The page you are looking for does not exist.",
  },
  "401": {
    errorCode: "401",
    errorImg: error401,
    errorTitle: "401_ERROR_TITLE",
    fallbackTitle: "Unauthorized",
    fallbackMessage: "You need to sign in to access this page.",
  },
  "403": {
    errorCode: "403",
    errorImg: error401,
    errorTitle: "403_ERROR_TITLE",
    fallbackTitle: "Access Denied",
    fallbackMessage: "You do not have permission to access this page. Please contact your administrator.",
  },
  "500": {
    errorCode: "500",
    errorImg: error500,
    errorTitle: "500_ERROR_TITLE",
    fallbackTitle: "Internal Server Error",
    fallbackMessage: "Something went wrong on our end.",
  },
}

const Exception: React.FC<{ fromErrorBoundary?: boolean }> = ({
  fromErrorBoundary,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const [exception, setException] = useState<any>({})

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const type = params.get("type") || "undefined"
    setException(exceptions[type] || {})
    
  }, [location.search])

  const handleBack = () => {
    if (fromErrorBoundary) {
      window.location.reload()
    } else {
      navigate("/")
    }
  }
  

  return (
    <Row className="skl-auto-marginTop-120" gutter={[16, 16]}>
      <div className="w-100 d-flex flex-column align-items-center">
        <div className="ml-3">
          <Image preview={false} width="328px" src={exception.errorImg} />
        </div>
        <div className="skl-text-3xl skl-font-weight-bold">
          {exception.fallbackTitle || L(exception.errorTitle || "UNDER_MAINTENANCE")}
        </div>
        <Button type="primary" className="skl-mt-2 " onClick={handleBack}>
          {L("BACK")}
        </Button>
      </div>
    </Row>
  )
}

export default Exception
